import Cookies from 'js-cookie';
import { call, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { setupIntent, createCustomerAndSetupIntent } from './api';
import {
  SETUP_INTENT_STRIPE_REQUEST,
  CREATE_CART_CUSTOMER_AND_SETUP_INTENT_FOR_STRIPE_REQUEST
} from './constants';

function* setup(action) {
  try {
    yield call(removeAPIError);
    const response = yield call(setupIntent);
    action.onSuccess(response.data);
  } catch (error) {
    yield call(addAPIError, error);
  }
}
function* createCustomerSetupIntent(action) {
  try {
    yield call(removeAPIError);
    const response = yield call(
      createCustomerAndSetupIntent,
      cartId(),
      action.paymentMethodData
    );
    action.onSuccess(response.data);
  } catch (error) {
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(SETUP_INTENT_STRIPE_REQUEST, setup);
  yield takeLatest(
    CREATE_CART_CUSTOMER_AND_SETUP_INTENT_FOR_STRIPE_REQUEST,
    createCustomerSetupIntent
  );
}

export default function* stripeSagas() {
  yield all([watchList()]);
}

const cartId = () => Cookies.get('cartId');
